import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updatePacienteInmunoterapiaAplicacion } from "../services/inmunoterapia.service";

import { dangerNotification, successNotification } from '../../../redux/slices/ui';

export const usePacienteInmunoterapiaAplicacionEditar = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const updateInmunoterapiaAplicacionMutation = useMutation({
        mutationFn: updatePacienteInmunoterapiaAplicacion,
        onSuccess: ({inmunoterapia, caducidad, limite}, variables, context) => {
            if(caducidad){
                variables.caducidad();
            }else if (limite){
                variables.limite();
            }else{
                variables.resetAccion();
                queryClient.invalidateQueries({ queryKey: ['paciente/inmunoterapia/proxima', id] });
                variables.success(inmunoterapia.aplicaciones);
                dispatch(successNotification('Aplicación actualizada'));
            }
        },
        onError: (error, variables, context) => {
            // console.log(error);
            dispatch(dangerNotification(error.message));
        },
    });

    return {
        updateInmunoterapiaAplicacionMutation,
    }
}